/**
 * Admin User Management Logic
 */
export function initUsers() {


    // Toggle Status (Activate/Deactivate) - Moved outside modalUser guard
    $(document).on('click', '.btn-toggle-status', function() {
        const id = $(this).data('id');
        const username = $(this).data('username');
        const status = $(this).data('status');
        const url = $(this).data('url-toggle');
        const action = status === 'active' ? 'Ban' : 'Activate';
        const actionText = status === 'active' ? 'non-aktifkan' : 'aktifkan';
        const color = status === 'active' ? '#dc3545' : '#198754';

        Swal.fire({
            title: 'Apakah Anda yakin?',
            text: `Anda akan ${actionText} user "${username}"`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: color,
            cancelButtonColor: '#6c757d',
            confirmButtonText: `Ya, ${action}!`,
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                // Get CSRF dynamically
                const csrfTokenName = $('input[name*="csrf_"]').first().attr('name') || 'csrf_test_name';
                const csrfHash = $('input[name*="csrf_"]').first().val() || '';
                let postData = {};
                postData[csrfTokenName] = csrfHash;

                $.post(url, postData, function(res) {
                    if (res.status === 'success') {
                        Swal.fire({
                            icon: 'success',
                            title: 'Status Updated',
                            text: res.message,
                            timer: 1500,
                            showConfirmButton: false
                        }).then(() => {
                            window.location.reload();
                        });
                    } else {
                        Swal.fire('Error', res.message, 'error');
                    }
                }).fail(function(xhr) {
                    Swal.fire('Error', xhr.responseJSON ? xhr.responseJSON.message : 'Error changing status', 'error');
                });
            }
        });
    });

    // Delete User
    $(document).on('click', '.btn-delete-user', function() {
        const username = $(this).data('username');
        const url = $(this).data('url-delete');

        Swal.fire({
            title: 'Hapus User?',
            text: `Anda akan menghapus user "${username}". Tindakan ini tidak dapat dibatalkan!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Ya, Hapus!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                // Get CSRF dynamically
                const csrfTokenName = $('input[name*="csrf_"]').first().attr('name') || 'csrf_test_name';
                const csrfHash = $('input[name*="csrf_"]').first().val() || '';
                let postData = {};
                postData[csrfTokenName] = csrfHash;

                $.post(url, postData, function(res) {
                    if (res.status === 'success') {
                        Swal.fire({ icon: 'success', title: 'Berhasil!', text: res.message, timer: 1500, showConfirmButton: false })
                            .then(() => { window.location.reload(); });
                    } else {
                        Swal.fire('Gagal!', res.message, 'error');
                    }
                }).fail(function(xhr) {
                    Swal.fire('Error!', xhr.responseJSON ? xhr.responseJSON.message : 'Gagal menghapus user', 'error');
                });
            }
        });
    });

    // Toggle password visibility
    $(document).on('click', '.toggle-password', function() {
        const targetId = $(this).data('target');
        const target = document.getElementById(targetId);
        const icon = this.querySelector('i');
        if (target.type === 'password') {
            target.type = 'text';
            icon.classList.replace('bi-eye', 'bi-eye-slash');
        } else {
            target.type = 'password';
            icon.classList.replace('bi-eye-slash', 'bi-eye');
        }
    });

    // Reset Password Modal - Moved outside modalUser guard
    const resetModalElem = document.getElementById('modalResetPassword');
    if (resetModalElem) {
        const resetModal = new bootstrap.Modal(resetModalElem);
        const resetForm = document.getElementById('formResetPassword');

        $(document).on('click', '.btn-reset-password', function() {
            const username = $(this).data('username');
            const url = $(this).data('url-reset');
            document.getElementById('resetUsername').textContent = username;
            resetForm.action = url;
            resetForm.querySelector('#resetPasswordInput').value = '';
            resetForm.querySelector('#resetPasswordConfirm').value = '';
            resetModal.show();
        });

        if (resetForm) {
            $(resetForm).on('submit', function(e) {
                e.preventDefault();
                e.stopPropagation();
                const pw = document.getElementById('resetPasswordInput').value;
                const confirm = document.getElementById('resetPasswordConfirm').value;
                if (pw !== confirm) {
                    Swal.fire('Error', 'Passwords do not match!', 'error');
                    return;
                }

                const $btn = $(this).find('button[type="submit"]');
                $btn.prop('disabled', true);

                $.ajax({
                    url: $(this).attr('action'),
                    type: 'POST',
                    data: $(this).serialize(),
                    success: function(res) {
                        if (res.status === 'success') {
                            resetModal.hide();
                            Swal.fire('Success', res.message, 'success');
                        } else {
                            Swal.fire('Error', res.message, 'error');
                        }
                    },
                    error: function(xhr) {
                        Swal.fire('Error', xhr.responseJSON ? xhr.responseJSON.message : 'Server Error', 'error');
                    },
                    complete: function() {
                        $btn.prop('disabled', false);
                    }
                });
            });
        }
    }

    const modalUserElem = document.getElementById('modalUser');
    if (!modalUserElem) return;

    const modalUser = new bootstrap.Modal(modalUserElem);
    const formUser = document.getElementById('formUser');
    const modalTitle = document.getElementById('modalUserLabel');
    const btnSubmit = document.getElementById('btnSubmitUser');
    const passwordField = document.getElementById('passwordField');
    const roleWarning = document.getElementById('roleWarning');
    const inputPassword = document.getElementById('password');

    // Reset for Create
    const btnCreateUser = document.getElementById('btnCreateUser');
    if (btnCreateUser) {
        btnCreateUser.addEventListener('click', function() {
            formUser.reset();
            formUser.action = this.dataset.urlStore;
            document.getElementById('formMethod').value = "POST";
            modalTitle.innerText = "Create New User";
            btnSubmit.innerText = "Create User";
            passwordField.classList.remove('d-none');
            roleWarning.classList.add('d-none');
            inputPassword.setAttribute('required', 'required');
            $('.select2-user').val('').trigger('change');
            modalUser.show();
        });
    }

    // Edit Handler
    $(document).on('click', '.btn-edit-user', function() {
        const id = $(this).data('id');
        const urlJson = $(this).data('url-json');
        const urlUpdate = $(this).data('url-update');
        
        Swal.fire({
            title: 'Loading Data...',
            didOpen: () => { Swal.showLoading(); }
        });

        $.get(urlJson, function(res) {
            Swal.close();
            if (res.status === 'success') {
                const data = res.data;
                formUser.action = urlUpdate;
                document.getElementById('formMethod').value = "POST"; 
                modalTitle.innerText = `Edit User: ${data.username}`;
                btnSubmit.innerText = "Update User";
                
                document.getElementById('username').value = data.username;
                document.getElementById('email').value = data.email;
                
                passwordField.classList.add('d-none'); 
                inputPassword.removeAttribute('required');
                roleWarning.classList.remove('d-none');
                
                if(data.roles && data.roles.length > 0) {
                    $('#role').val(data.roles[0]).trigger('change');
                }

                if(data.id_pegawai) {
                    $('#id_pegawai').val(data.id_pegawai).trigger('change');
                } else {
                    $('#id_pegawai').val('').trigger('change');
                }

                modalUser.show();
            } else {
                Swal.fire('Error', res.message || 'Gagal mengambil data', 'error');
            }
        }).fail(function() {
            Swal.fire('Error', 'Failed to fetch user data', 'error');
        });
    });

    // --- AJAX Submit for User Form (Create/Edit) ---
    $(formUser).on('submit', function(e) {
        e.preventDefault();
        const actionUrl = $(this).attr('action');
        const $btn = $(btnSubmit);
        const originalHtml = $btn.html();

        $btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1"></span> Processing...');

        $.ajax({
            url: actionUrl,
            type: 'POST',
            data: $(this).serialize(),
            success: function(response) {
                if(response.status === 'success') {
                    modalUser.hide();
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: response.message,
                        timer: 1500,
                        showConfirmButton: false
                    }).then(() => {
                        window.location.reload();
                    });
                } else {
                    Swal.fire('Gagal', response.message || 'Terjadi kesalahan', 'error');
                }
            },
            error: function(xhr) {
                const res = xhr.responseJSON;
                const msg = res ? (res.message + (res.errors ? ' - ' + Object.values(res.errors).join(', ') : '')) : 'Terjadi Kesalahan';
                Swal.fire('Error!', msg, 'error');
            },
            complete: function() {
                $btn.prop('disabled', false).html(originalHtml);
            }
        });
    });
}

/**
 * Users Create Page — pegawai auto-fill + AJAX submit
 */
export function initUsersCreate() {
    const $page = $('#page-id');
    const DETAIL_URL = $page.data('detail-url');
    const INDEX_URL  = $page.data('index-url');

    _initPegawaiAutoFill(DETAIL_URL);
    _initFormAjax('#formCreateUser', INDEX_URL);
}

/**
 * Users Edit Page — pegawai auto-fill + AJAX submit
 */
export function initUsersEdit() {
    const $page = $('#page-id');
    const DETAIL_URL = $page.data('detail-url');
    const INDEX_URL  = $page.data('index-url');

    _initPegawaiAutoFill(DETAIL_URL);
    _initFormAjax('#formEditUser', INDEX_URL);

    // Trigger auto-fill on page load if a pegawai is already selected (e.g. on Edit page)
    if ($('#id_pegawai').val()) {
        $('#id_pegawai').trigger('change');
    }
}

/**
 * Shared: Auto-fill UID/UP3/ULP when pegawai is selected
 */
function _initPegawaiAutoFill(detailUrl) {
    $('#id_pegawai').on('change', function() {
        const id = $(this).val();
        if (!id) {
            $('#id_level_jabatan, #nama_level_jabatan').val('');
            $('#id_uid, #nama_uid').val('');
            $('#id_up3, #nama_up3').val('');
            $('#id_ulp, #nama_ulp').val('');
            return;
        }
        $.getJSON(detailUrl, { id: id }, function(res) {
            if (res.status === 'success' && res.data) {
                const d = res.data;
                
                // Level Jabatan
                $('#id_level').val(d.id_level || '');
                $('#nama_level').val(d.level_nama || '-');
                
                // UID
                $('#id_uid').val(d.id_uid || '');
                $('#nama_uid').val(d.nama_uid || '-');
                
                // UP3
                $('#id_up3').val(d.id_up3 || '');
                $('#nama_up3').val(d.nama_up3 || '-');
                
                // ULP
                $('#id_ulp').val(d.id_ulp || '');
                $('#nama_ulp').val(d.nama_ulp || '-');
            }
        });
    });
}

/**
 * Shared: AJAX form submit with SweetAlert feedback
 */
function _initFormAjax(formSelector, redirectUrl) {
    $(formSelector).on('submit', function(e) {
        e.preventDefault();
        const $btn = $(this).find('button[type="submit"]');
        const origHtml = $btn.html();
        $btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-2"></span>Menyimpan...');
        $.ajax({
            url: $(this).attr('action'),
            method: 'POST',
            data: $(this).serialize(),
            success: function(res) {
                if (res.status === 'success') {
                    Swal.fire({ icon: 'success', title: 'Berhasil!', text: res.message, timer: 2000, showConfirmButton: false })
                        .then(() => { window.location.href = redirectUrl; });
                }
            },
            error: function(xhr) {
                $btn.prop('disabled', false).html(origHtml);
                const r = xhr.responseJSON;
                let msg = 'Terjadi kesalahan sistem.';
                if (r && r.errors) msg = Object.values(r.errors).join('<br>');
                else if (r && r.message) msg = r.message;
                Swal.fire({ icon: 'error', title: 'Gagal!', html: msg });
            }
        });
    });
}


